import { useEffect, useState } from "react";

// Shared offline status (online flag, pending/conflict counts, last sync) with subscribers.
let state = { online: typeof navigator === "undefined" ? true : navigator.onLine, pending: 0, conflicts: [], entities: {}, justSynced: {}, sending: null, lastSync: null, syncing: false };
const subs = new Set();

export const getState = () => state;
export function setState(patch) {
  state = { ...state, ...patch };
  subs.forEach((fn) => fn(state));
}
export function useOfflineState() {
  const [s, set] = useState(state);
  useEffect(() => {
    subs.add(set);
    return () => { subs.delete(set); };
  }, []);
  return s;
}

export const TTL_MS = 72 * 3600 * 1000;

export function httpError(status, detail) {
  const e = new Error(typeof detail === "string" ? detail : "Erreur");
  e.response = { status, data: { detail } };
  return e;
}

export function isNetworkError(e) {
  return !e?.response && e?.code !== "ERR_CANCELED";
}
